import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { ChartSeries } from '../../../../../models/account-creation-point.model';
import { ChartCardComponent } from '../../../shared/chart-card/chart-card.component';

/** "New Organization Creation" area chart with a 30 / 60 / 90 days chip selector. */
@Component({
    selector: 'r1-account-creation-chart',
    template: `
        <r1-chart-card
            title="New Organization Creation"
            kind="area"
            [series]="series()"
            [days]="days()"
            [dayOptions]="[30, 60, 90]"
            (daysChange)="daysChange.emit($event)"
            xLabel="Week Created At"
            yLabel="Organizations"
            emptyMessage="No organizations were created in the selected period." />
    `,
    styles: `
        :host {
            display: block;
            height: 100%;
        }
    `,
    imports: [ChartCardComponent],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccountCreationChartComponent {
    series = input.required<ChartSeries[]>();
    days = input.required<number>();
    daysChange = output<number>();
}
